import { Injectable } from '@angular/core';

@Injectable()
export class AppProperties {
  readonly API_LOGIN_URL = 'https://amquery.rokomari.io/api/v1/auth/login';
  readonly API_LOGIN_REFRESH_URL = 'https://amquery.rokomari.io/api/v1/auth/refresh'
  readonly API_URL = 'https://amquery.rokomari.io/api/v1/activities/query';
}

